import { render, staticRenderFns } from "./LimitsTable.vue?vue&type=template&id=4da9fe1b&scoped=true"
import script from "./LimitsTable.vue?vue&type=script&lang=ts"
export * from "./LimitsTable.vue?vue&type=script&lang=ts"
import style0 from "./LimitsTable.vue?vue&type=style&index=0&id=4da9fe1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da9fe1b",
  null
  
)

export default component.exports